import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import styled, { css } from 'styled-components';
import { StepperOperations, StepperSelectors } from '../../ducks/stepper';
import { stepsConfigFlat, stageConfig } from './stageConfig';
import { getColor } from '@panel/commons/core/themev3';
import { useLocation, useHistory, useRouteMatch } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { getDevice } from '@panel/commons/helpers';
import { select } from '@panel/commons/core/themev2';
import { useQuery } from '@panel/commons/hooks';

const Stepper = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const { currentStep } = useSelector(StepperSelectors.getStepperState);
  const { params } = useRouteMatch('/publicador-profesionales/:step?');
  const [isEdition] = useQuery(useLocation(), ['isEdition']);

  useEffect(() => {
    const timer = setTimeout(() => {
      Object.values(stepsConfigFlat).forEach(({ stepId, path }) => {
        if (params.step && path.endsWith(params.step)) {
          // revisa que exista el postingId en la url sino redirige al paso 1
          if (!location.pathname.includes('main') && !new URLSearchParams(location.search).get('postingId')) {
            window.location.href = '/panel/publicador-profesionales/main';
          }
          dispatch(StepperOperations.setCurrentStep(stepId));
        }
      });
    }, 1); // Pequeño delay para asegurar que la transición se ejecute

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, location.search, history]);

  const calculateStageFill = stage => {
    const lastStepIdByStage = stage.steps[stage.steps?.length - 1]?.stepId;
    const firstStepIdByStage = stage.steps[0]?.stepId;
    const maxPercent = 100;

    if (stage.stageId === 3 && currentStep === 8 && !isEdition) return 95;
    if (currentStep < firstStepIdByStage) return 0;
    if (currentStep > lastStepIdByStage) return maxPercent;
    return (maxPercent / stage?.steps?.length) * Number(currentStep - firstStepIdByStage + 1);
  };

  return (
    <Container device={getDevice()}>
      {stageConfig.map(s => {
        return (
          <StepperBar key={s.stageId}>
            <StepperBarFill widthPercent={calculateStageFill(s)} />
          </StepperBar>
        );
      })}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  width: 100%;
  gap: 4px;
  padding: 0px ${({ device }) => (device === 'mobile' ? 14 : 0)}px;
  padding-bottom: ${({ device }) => (device === 'mobile' ? 8 : 0)}px;
  ${({ device }) =>
    device === 'mobile' &&
    css`
      border-bottom: 2px solid ${select('lightGray')};
    `}
`;

const StepperBar = styled.div`
  height: 4px;
  flex: 1;
  border-radius: 8px;
  background-color: ${select('midNeutralGray')};
  position: relative;
`;

const StepperBarFill = styled.div`
  position: absolute;
  border-radius: 8px;
  left: 0;
  height: 100%;
  width: ${({ widthPercent }) => widthPercent}%;
  transition: width 0.7s ease-in-out;
  background-color: ${getColor('primary')};
`;

export default Stepper;
